import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Hyperlink } from '../../../components/atoms/Hyperlink';
import Btn, { BtnModifier } from '../../../components/molecules/Btn';
import { Icons } from '../../../components/atoms/SVG';
import { writeTextToClipBoard } from '../../../lib/Clipboard/clipboardUtils';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

export function CopyableLink({ to }: { to: string }) {
  const { t } = useSonTranslation('NavigationPropertiesForm');
  const url = new URL(to);

  return (
    <div className="copyable-link">
      <p>
        <dfn className="invisible">{t('inputs.descriptiveUrl.dfn')}: </dfn>
        {/*  keep routing = false here, we dont want a spa navigation, as this links is a redirect */}
        <Hyperlink routing={false} className="copyable-link__link" to={url.pathname}>
          {url.href}
        </Hyperlink>
      </p>
      <div className="copyable-link__button">
        <Btn
          modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
          svgSpriteId={Icons.COPY_PASTE}
          titleText={t('inputs.descriptiveUrl.copyLink')}
          text={t('inputs.descriptiveUrl.copyLink')}
          hiddenText
          onClick={writeTextToClipBoard(url.href)}
          tooltipPlacement={TooltipPlacement.TOP}
        />
      </div>
    </div>
  );
}
